import React from 'react';
import { Security, Speed, Code, CloudDownload } from '@mui/icons-material';

const SdkFeatures = () => {
    const features = [
        {
            icon: Security,
            title: 'Sécurisé par Défaut',
            description: 'Chiffrement TLS, validation des données et gestion sécurisée des tokens'
        },
        {
            icon: Speed,
            title: 'Haute Performance',
            description: 'Optimisé pour la vitesse avec mise en cache intelligente et connexions persistantes'
        },
        {
            icon: Code,
            title: 'Typage Fort',
            description: 'Support TypeScript natif avec des types complets pour toutes les APIs'
        },
        {
            icon: CloudDownload,
            title: 'Mises à Jour Automatiques',
            description: 'Gestion des versions sémantiques et notifications de mises à jour de sécurité'
        }
    ];

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-6">Fonctionnalités du SDK</h3>

            <div className="space-y-4">
                {features.map((feature, index) => (
                    <div key={index} className="flex items-start space-x-4">
                        <div className="p-2 bg-amber-100 rounded-lg mt-1">
                            <feature.icon className="text-amber-600 text-lg" />
                        </div>
                        <div>
                            <h4 className="font-semibold text-gray-900 mb-1">{feature.title}</h4>
                            <p className="text-sm text-gray-600">{feature.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Version Info */}
            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                <h4 className="font-medium text-gray-900 mb-2">Dernière Version</h4>
                <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Node.js SDK</span>
                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium">v2.1.0</span>
                </div>
                <div className="text-xs text-gray-500 mt-2">Publié il y a 3 jours • 2.4k téléchargements</div>
            </div>
        </div>
    );
};

export default SdkFeatures;